import {collection, getDocs, query} from "firebase/firestore";
import {fire} from "../../fire";

export const obtenerColWheres = ({col, wheres = []}) => {

    let q = new query(collection(fire, col), ...wheres)

    return new Promise(resolve => {

        getDocs(q).then((dox) => {

            let arr = []
            for (let i = 0; i < dox.docs.length; i++) {
                arr.push(dox.docs[i].data())
            }

            return resolve({res: true, data: arr})
        }).catch((err) => {
            console.log(err)
            return resolve({res: false, data: err.message})
        })
    })

}